<template>
  <div class="modal-card" data-cy="modal-card">
    <header>
      <h3>Alguien paga tu dividendo por tí</h3>
      <a class="close-modal-button" @click="$emit('is-modal-active', false)">
        <img src="@/ui/assets/img/plus-button.svg">
      </a>
    </header>
    <p class="description-text">
      Si utilizas transferencia electrónica como medio de pago,
      aquí puedes indicarnos los datos de una persona distinta de ti para que podamos reconocer rápidamente el abono.
    </p>
    <div class="add-section">
      <b-button
        v-if="!showAddTrustedIdInput"
        id="button-add-person"
        class="is-button-primary add-button"
        type="is-medium"
        icon-left="fas fa-user-plus"
        rounded
        @click="showAddTrustedIdInput = !showAddTrustedIdInput">
        Agregar persona
      </b-button>
      <div v-if="showAddTrustedIdInput" id="div-add-person" class="card-item input-card">
        <div class="input-card-name">
          <p class="is-size-6 p-title">Nombre:</p>
          <input
            id="input-name"
            v-model="trustedIdToAdd.name"
            type="text"
            size="is-small"
            class="input is-small input-name">
        </div>
        <div class="input-card-rut">
          <p class="is-size-6 p-title-rut">Rut:</p>
          <input
            id="input-rut"
            v-model="trustedIdToAdd.idNumber"
            type="text"
            size="is-small"
            placeholder="Ej: 12123123-1"
            class="input is-small input-rut">
        </div>
        <div class="input-card-button">
          <b-button
            id="button-cancel-person"
            class="is-button-secondary button"
            type="is-small"
            rounded
            @click="showAddTrustedIdInput = !showAddTrustedIdInput">
            Cancelar
          </b-button>
          <b-button
            id="button-add-person"
            class="is-button-primary button"
            type="is-small"
            rounded
            @click="setOrUnsetTrustedIdNumber([trustedIdToAdd])">
            Agregar
          </b-button>
        </div>
      </div>
    </div>
    <div class="trusted-ids-list">
      <h5 v-if="modifiableTrustedIdNumbers.length" class="transfers-title">Tus personas de confianza</h5>
      <div v-for="trustedIdNumber in modifiableTrustedIdNumbers" :key="trustedIdNumber.idNumber">
        <div class="card-item input-card">
          <div class="input-card-name">
            <p class="is-size-6 is-primary p-title">Nombre:</p>
            <p class="p-rut">{{ trustedIdNumber.name }}</p>
          </div>
          <div class="input-card-rut">
            <p class="is-size-6 p-title">Rut:</p>
            <p class="p-rut">{{ formatRut(trustedIdNumber.idNumber) }}</p>
          </div>
          <div class="input-card-button">
            <b-button
              id="delete-button"
              class="is-button-primary button"
              type="is-small"
              rounded
              @click="setOrUnsetTrustedIdNumber([
                {
                  idNumber: trustedIdNumber.idNumber,
                  name: trustedIdNumber.name,
                  status: 'DELETED_BY_CLIENT'
                }
              ])">
              Eliminar
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { IdNumberValidatorCL } from 'creditu-types/validators/id-number';
import { formatNumber } from '@/infrastructure/format';
import { getClient, setOrUnsetClientTrustedIdNumbers } from '@/application/services/api-clients/clients';

export default {
  name: 'TrustedIdNumbers',
  data() {
    return {
      currentClient: { trustedIdNumbers: [] },
      showAddTrustedIdInput: false,
      trustedIdToAdd: {
        status: 'ADDED_BY_CLIENT',
        name: '',
        idNumber: ''
      }
    };
  },
  computed: {
    modifiableTrustedIdNumbers() {
      return this.currentClient.trustedIdNumbers.filter(trustedIdNumbers => !['DEFAULT', 'DELETED_BY_CLIENT'].includes(trustedIdNumbers.status));
    }
  },
  async mounted() {
    await this.loadData();
  },
  methods: {
    async loadData() {
      try {
        this.currentClient = await getClient(this.$store.state.currentUser.user.clientId);
      } catch (_error) {
        this.alert({ message: 'Hubo un error al tratar de comunicarnos con el servidor', alertType: '' });
        this.$emit('is-modal-active', false);
      }
    },
    async setOrUnsetTrustedIdNumber(trustedIdNumbers) {
      const idNumberValidatorCL = new IdNumberValidatorCL();
      const allIdNumbersAreValid = trustedIdNumbers.every(({ idNumber }) => idNumberValidatorCL.validate(idNumber));
      if (allIdNumbersAreValid === false) {
        this.alert({ message: 'El RUT ingresado no es válido, corrígelo e intenta nuevamente', alertType: 'is-danger' });
        return;
      }
      const trustedIdNumbersToSend = JSON.parse(JSON.stringify(trustedIdNumbers));
      try {
        await this.loadData();
        await setOrUnsetClientTrustedIdNumbers(this.currentClient._id, trustedIdNumbersToSend);
      } catch (_error) {
        this.alert({ message: 'Hubo un error al tratar de comunicarnos con el servidor', alertType: '' });
      }
      await this.loadData();
      this.trustedIdToAdd = {
        status: 'ADDED_BY_CLIENT',
        name: '',
        idNumber: ''
      };
      this.showAddTrustedIdInput = false;
    },
    alert({ message, alertType }) {
      this.$buefy.notification.open({
        duration: 3000,
        message,
        type: alertType,
        hasIcon: true
      });
    },
    formatNumber: number => formatNumber({ number }),
    formatRut(rut) {
      const rutParts = rut.split('-');
      return `${this.formatNumber(Number(rutParts[0]))}-${rutParts[1]}`;
    }
  }
};
</script>

<style scoped>
.modal-card {
  display: flex;
  flex-flow: column nowrap;
  gap: 2rem;
  background-color: var(--color-snow);
  padding: 2rem;
  width:100%;
  overflow: auto;
  max-height: 50rem;
}
header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
header h3 {
  margin: 0rem;
}
header .close-modal-button {
  width: 2.5rem;
  height: 2.5rem;
}
.description-text {
  font-size: 1rem;
  text-align: justify;
}
.p-title {
  color: var(--primary);
  font-weight: 600;
}
.p-title-rut {
  width: 60px;
  color: var(--primary);
  font-weight: 600;
}
.add-section {
  display: flex;
  align-items: center;
  justify-content: center;
}
.add-section .add-button {
  height: 2.5rem;
  width: 30%;
  min-width: 10rem;
}
.input-card {
  display: grid;
  grid: "col1 col2 col3" auto
    / minmax(auto, 1fr) minmax(auto, 1fr) auto;
  justify-content: center;
  place-items: center start;
  gap: 1rem;
}
.input-card .input-card-name {
  grid-area: col1;
}
.input-card .input-card-rut {
  grid-area: col2;
}
.input-card .input-card-button {
  grid-area: col3;
  justify-self: end;
}
.input-card-name, .input-card-rut, .input-card-button {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: center;
  gap: 0.5rem 1rem;
}
.button {
  font-size: 0.9rem;
}
.trusted-ids-list {
  display: flex;
  flex-flow: column wrap;
  gap: 2rem;
}
.input-rut, .input-name {
  width: 10rem;
  border-radius: 10rem;
  border: 1px solid var(--color-silver);
}
.input-rut:focus {
  border: 1px solid var(--primary);
}
@media (max-width: 870px) {
  .input-card {
    grid:
      "col1 col2" auto
      "col3 col3" auto
      / 1fr 1fr;
    justify-content: center;
    place-items: center;
    gap: 1rem;
  }
  .input-card .input-card-button {
    justify-self: center;
  }
  .p-rut {
    width: 100%;
    text-align: center;
  }
}
@media (max-width: 550px) {
  .input-card {
    grid:
      "col1" auto
      "col2" auto
      "col3" auto;
    justify-content: center;
    place-items: center stretch;
    gap: 1rem;
  }
  .input-card-name, .input-card-rut{
    justify-content: flex-start;
    width: 350px;
  }
  .input-name, .input-rut {
    width: 220px;
  }
  .p-rut {
    text-align: left;
  }
}
@media (max-width: 450px) {
  h3 {
    font-size: 1.2rem;
  }
  .description-text {
    font-size: 0.9rem;
  }
  .input-card-name, .input-card-rut {
    width: 220px;
  }
}
</style>
